function readVar(name: string, fallback: string): string {
  const v = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
  return v || fallback;
}

function hexToNumber(hex: string): number {
  return parseInt(hex.replace("#", ""), 16);
}

function color(name: string, fallback: string): number {
  return hexToNumber(readVar(name, fallback));
}

export const THEME = {
  bgDeep:      color("--bg-deep",      "#0c1612"),
  bgPanel:     color("--bg-panel",     "#18241e"),
  bgElevated:  color("--bg-elevated",  "#25382c"),
  borderSubtle:color("--border-subtle","#3a5a48"),
  borderAccent:color("--border-accent","#c8a857"),
  leafGlow:    color("--leaf-glow",    "#e8c970"),
  textPrimary: color("--text-primary", "#f4ecd6"),
  textMuted:   color("--text-muted",   "#8a9a85"),
  textAccent:  color("--text-accent",  "#c8a857"),
  hope:        color("--state-hope",   "#4a8a5a"),
  fear:        color("--state-fear",   "#9a5a6a"),
  success:     color("--state-success","#5a9a5a"),
  danger:      color("--state-danger", "#b85a4a"),
  disabled:    color("--state-disabled","#3a4a3a"),

  hopeMuted:   0x2d5a3a,
  fearMuted:   0x5a3a4a,
  hopeBright:  0x5a8a55,
  fearBright:  0xa06370,

  kindAttack:  0xa86a3a,
  kindSpell:   0x3a6a5a,
  kindAction:  0x5a7a55,
};

export function domainAccent(domainId: string): number {
  return color(`--domain-${domainId}`, "#c8a857");
}

export const TEXT_STYLE = {
  display: {
    fontFamily: "'Cinzel', 'Georgia', serif",
    color: "#c8a04a",
    resolution: Math.max(1, window.devicePixelRatio || 1),
  },
  body: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "#e8e4d6",
    resolution: Math.max(1, window.devicePixelRatio || 1),
  },
  small: {
    fontFamily: "'Inter', 'Segoe UI', sans-serif",
    color: "#9a9583",
    resolution: Math.max(1, window.devicePixelRatio || 1),
  },
};
